<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="orderPopup()">新增订单</el-button>
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span class="el-icon-refresh icon-hover refresh-btn" @click="debounceRefresh"></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="orderCode" label="订单编号">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.orderCode }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="merchantName" label="销售商"></el-table-column>
      <el-table-column prop="deliveryName" label="发货人"></el-table-column>
      <el-table-column prop="receiverName" label="收货人"></el-table-column>
      <el-table-column prop="receiverPhone" label="收货人电话"></el-table-column>
      <el-table-column prop="receiverAddress" label="收货人地址"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="orderPopup(scope.row.id)">编辑</el-button>
          <el-button type="text" @click="orderDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    ></pagination>
    <!-- 订单表单 -->
    <Dialog :title="title" :visible.sync="drawer" :with-header="false" center width="85%">
      <OrderForm ref="orderDrawer" @cancel="cancel" @afterRefresh="afterRefresh" :orderId="orderId" />
    </Dialog>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawerDetail" size="40%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawerDetail = false"></i>
          <span>订单详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">订单编号</td>
            <td>{{ detailDate.orderCode }}</td>
            <td class="list-item">订单时间</td>
            <td>{{ detailDate.sendDate | formatDate }}</td>
          </tr>
          <tr>
            <td class="list-item">销售商</td>
            <td>{{ detailDate.merchantName }}</td>
            <td class="list-item">发货人</td>
            <td>{{ detailDate.deliveryName }}</td>
          </tr>
          <tr>
            <td class="list-item">发货人电话</td>
            <td>{{ detailDate.deliveryPhone }}</td>
            <td class="list-item">发货地址</td>
            <td>{{ detailDate.deliveryAddress }}</td>
          </tr>
          <tr>
            <td class="list-item">发货地区</td>
            <td>{{ detailDate.deliveryProvinceName + detailDate.deliveryCityName + detailDate.deliveryCountyName + detailDate.deliveryTownName }}</td>
            <td class="list-item">收货人</td>
            <td>{{ detailDate.receiverName }}</td>
          </tr>
          <tr>
            <td class="list-item">收货人电话</td>
            <td>{{ detailDate.receiverPhone }}</td>
            <td class="list-item">收货地址</td>
            <td>{{ detailDate.receiverAddress }}</td>
          </tr>
          <tr>
            <td class="list-item">收货人电话</td>
            <td>{{ detailDate.receiverPhone }}</td>
            <td class="list-item">收货地区</td>
            <td>{{ detailDate.receiverProvinceName + detailDate.receiverCityName + detailDate.receiverCountyName + detailDate.receiverTownName }}</td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import OrderForm from './components/OrderForm'
import {
  getOrderList,
  getOrderDetail,
  deleteOrderDel,
  delOrderList
} from '@/api/order'

export default {
  components: {
    OrderForm
  },
  data() {
    return {
      drawer: false,
      isDisabled: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      loading: true,
      detailDate: {},
      drawerDetail: false,
      selectionID: [],
      tableData: [],
      orderId: null,
      currentID: null
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑订单' : '新增订单'
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delOrderList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getOrderListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getOrderListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getOrderListData()
    },
    cancel() {
      this.drawer = false
    },
    // 删除订单
    orderDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteOrderDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除订单成功')
              this.getOrderListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增完成后刷新
    afterRefresh() {
      this.getOrderListData()
    },
    // 打开表单
    orderPopup(id) {
      console.log(id)
      this.drawer = true
      if (id) {
        this.orderId = id
        this.$nextTick(() => {
          this.$refs.orderDrawer.setForm()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.orderDrawer.setForm()
        })
        this.orderId = undefined
      }
    },
    // 检索
    search() {
      this.getOrderListData()
    },
    // 刷新数据表格
    refresh() {
      this.getOrderListData()
      this.$message.success('数据刷新成功')
    },
    // 订单详情
    detailShow(id) {
      this.drawerDetail = true
      getOrderDetail(id).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取订单列表
    getOrderListData() {
      this.loading = true
      getOrderList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    }
  },
  mounted() {
    this.getOrderListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
